import React, { ChangeEvent, useRef } from "react";

import { SxProps } from "@mui/material";
import TextField from "@mui/material/TextField";

interface TextAreaComponent {
  label?: string;
  rows?: number;
  onChange: (text: string) => void;
  variant?: "outlined" | "filled" | "standard";
  value: string;
  fullWidth?: boolean;
  sx?: SxProps;
  placeholder?: string;
  autoFocus?: boolean;
}

export const TextAreaComponent: React.FC<TextAreaComponent> = ({
  label,
  rows = 4,
  onChange,
  variant = "outlined",
  value,
  fullWidth = true,
  sx,
  placeholder,
  autoFocus = false,
}) => {
  const textAreaRef = useRef<HTMLTextAreaElement | null>(null);

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    onChange(event.target.value);
  };

  const handleFocus = () => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = "auto";
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
    }
  };

  return (
    <TextField
      multiline
      inputRef={textAreaRef}
      rows={rows}
      variant={variant}
      label={label}
      onChange={handleChange}
      onFocus={handleFocus}
      value={value}
      fullWidth={fullWidth}
      sx={sx}
      autoFocus={autoFocus}
      inputProps={{
        maxLength: 5000,
      }}
      placeholder={placeholder}
    />
  );
};
